import React from 'react';
import './sectionhero.css';
import logo from '../../../assets/img/logo-2021.webp';
import profile from '../../../assets/img/profile4.webp';

export default function SectionHero() {
	const ageKonfisio = () => {
		const date = new Date();
		const age = date.getFullYear() - 2000;
		return age;
	};

	return (
		<section id="hero">
			<div className="px-4 py-3 text-center">
				<img className="img-fluid d-block mx-auto my-5" src={logo} alt="Konfisio" width="400" height="400" />
				<div className="col-lg-6 mx-auto">
					<p className="lead mb-4 fw-bold">{'Formação profissional para quem quer atuar com segurança e resultado.'}</p>
					<p className="lead mb-4">{`Há mais de ${ageKonfisio()} anos, a Konfisio forma profissionais nas áreas de Fisioterapia, Estética e Saúde, unindo ciência, prática clínica e experiência real de mercado.`}</p>
					<div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
						<a
							href="https://api.whatsapp.com/send?phone=5522999329536&text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20cursos%20da%20Konfisio"
							target="_blank"
							rel="noreferrer"
							className="btn btn-md konfisio-color-bg btn-secondary px-2 mx-1"
						>
							<i className="fa-brands fa-whatsapp me-2" />
							Entrar em contato
						</a>
					</div>
				</div>
			</div>
			<div className="container px-4 my-2">
				<div className="row justify-content-center align-items-center py-3">
					<div className="col-10 col-lg-4 mx-3">
						<img src={profile} className="img-fluid mx-auto d-block img-profile my-3" alt="Dra. Karina Barcelos" width="350" height="500" loading="lazy" />
					</div>
					<div className="col-lg-7 p-3">
						<p>
							<strong>&quot;PARA CIMA DO MEDO, CORAGEM!&quot;</strong>
						</p>
						<p>
							<strong>Professora Karina Barcelos </strong>
							— Mestre, Fisioterapeuta e Nutricionista. Pós-graduada em Fisioterapia Dermatofuncional, Recursos Terapêuticos Manuais, Acupuntura, Dietoterapia Chinesa, Obesidade e Emagrecimento, Nutrição Esportiva e Funcional. Coordenadora de Pós-Graduação e Docente da Universidade Salgado de Oliveira. Atualmente, cursa pós-graduações em Fisioterapia Forense, Gestão de Unidades de Alimentação e Nutrição (UAN), Psicanálise, Neurociências e Orto-Molecular. {/* eslint-disable-line */}
							Reconhecida por sua atuação multidisciplinar e visão integrativa da saúde, alia ciência, experiência clínica e didática para formar profissionais de excelência nas áreas da Fisioterapia, Estética, Massoterapia e da Nutrição. {/* eslint-disable-line */}
						</p>
						<div className="d-grid gap-2 d-md-flex justify-content-md-start">
							<a href="https://instagram.com/konfisioka" target="_blank" rel="noreferrer" className="btn btn-md konfisio-color-bg btn-secondary px-2 mx-1">
								<i className="fa-brands fa-instagram me-2" />
								konfisioka
							</a>
							<a href="http://lattes.cnpq.br/0966239944268512" target="_blank" rel="noreferrer" className="btn btn-md konfisio-color-bg btn-secondary px-2 mx-1">Acesse Lattes</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
